<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  <pr-input label="Investissement" suffix="€" [derrors]="derrors">
    <input formControlName="investedAmount" type="text" />
  </pr-input>

  <pr-input label="Taux défiscalisation" [derrors]="derrors">
    <mat-select formControlName="reductionRate">
      @for (deficalisation of defiscalisations; track deficalisation) {
        <mat-option [value]="deficalisation.id">
          {{ deficalisation.name }}
        </mat-option>
      }
    </mat-select>
  </pr-input>
</pr-form>
